module.exports = __webpack_public_path__ + "img/stop.26f62c58.svg";